export class SweetFaceEmployeeDto {
  // @ApiProperty({
  //   description: 'Employee ID',
  //   example: 1,
  // })
  id: number;

  // @ApiProperty({
  //   description: 'Employee first name',
  //   nullable: false,
  //   example: 'John',
  // })
  firstName: string;

  // @ApiProperty({
  //   description: 'Employee last name',
  //   nullable: false,
  //   example: 'Smith',
  // })
  lastName: string;

  // @ApiProperty({
  //   description: 'Manager access PIN',
  //   nullable: true,
  //   example: '123456',
  // })
  managerAccessPin: string | null;

  // @ApiProperty({
  //   description: 'Manager PIN active boolean flag',
  //   nullable: false,
  //   example: true,
  // })
  managerPinActive: boolean;

  // @ApiProperty({
  //   description: 'Manager PIN active boolean flag',
  //   nullable: false,
  //   example: true,
  // })
  isActive: boolean;
}
